import PropTypes from 'prop-types';
import { findIndex } from 'lodash';
import { useEffect, useState, useRef, useCallback } from 'react';
import Scrollbar from '../../components/Scrollbar';
import flashFill from '@iconify/icons-eva/flash-fill';
import phoneCallFill from '@iconify/icons-eva/phone-call-fill';
import { MIconButton } from '../../components/@material-extend';
import { Icon } from '@iconify/react';
import { ListItemAvatar, Typography, ListItemText, Avatar, ListItemButton, Tooltip, IconButton, Stack, Box, Button, OutlinedInput, InputAdornment } from '@material-ui/core';


// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64;

export default function ListQuickContacts({ contacts, loadMoreContacts, callContact, page, endPage }) {
    const scrollRef = useRef();

    useEffect(() => {
        const scrollContactsToBottom = () => {
            if (scrollRef.current && page > 1) {
                console.log({scrollTop: scrollRef.current.scrollHeight  - 534 })
                scrollRef.current.scrollTop = scrollRef.current.scrollHeight  - 1100;
                
            } else {
                scrollRef.current.scrollTop = 0;
              
            }
        };
        scrollContactsToBottom();
    }, [contacts]);
    const handleScroll = useCallback(() => {
        console.log(scrollRef.current.scrollTop + 512)
        console.log(scrollRef.current.scrollHeight)
        if (scrollRef.current.scrollTop + 512 == scrollRef.current.scrollHeight) {
            // if (!endPage) {
            loadMoreContacts();
            //}
        }
    })

    useEffect(() => {
        const div = scrollRef.current;
        div.addEventListener("scroll", handleScroll);
        return () => div.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);
    return (

        <Scrollbar scrollableNodeProps={{ ref: scrollRef }} sx={{ flexGrow: 1 }}>
            <Stack spacing={3} sx={{ p: 2 }}>
                {contacts && contacts.map((contact) => {
                    const { id, name, avatar, status, phone } = contact;

                    return (
                        <Stack direction="row" alignItems="center" key={id}>
                            <Avatar src={avatar} sx={{ width: 48, height: 48 }} />
                            <Box sx={{ flexGrow: 1, ml: 2, minWidth: 100 }}>
                                <Typography variant="subtitle2" sx={{ mb: 0.5 }} noWrap>
                                    {name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                                    {phone}
                                </Typography>
                            </Box>

                            <Tooltip title="Gọi điện">
                                <MIconButton onClick={() => callContact(phone)} size="small">
                                    <Icon icon={phoneCallFill} width={22} height={22} />
                                </MIconButton>
                            </Tooltip>
                        </Stack>
                    );
                })}
            </Stack>
        </Scrollbar>
    );
}
